import React, { useState } from "react";
import { useFormikContext } from "formik";

import TotalReceivingUnitsModal from "../TotalReceivingUnits/TotalReceivingUnitsModal";
import UnitsFormInput from "./UnitsFormInput";

import { shipmentTypes } from "../../../../../constants/receiving-wizard";

export default function UnitsFormField({
  name,
  title,
  value,
  label,
  typeLabel,
  quantityLabel,
  addLabel,
}) {
  const [open, setOpen] = useState(false);
  const { setFieldValue } = useFormikContext();

  const handleToggle = () => {
    setOpen(v => !v);
  };

  const handleSave = list => {
    setFieldValue("totalPieces", list);
    handleToggle();
  };

  return (
    <>
      <UnitsFormInput name={name} label={label} value={value} onClick={handleToggle} />
      {open && (
        <TotalReceivingUnitsModal
          title={title}
          value={value}
          onClose={handleToggle}
          onSave={handleSave}
          typeLabel={typeLabel}
          quantityLabel={quantityLabel}
          addLabel={addLabel}
          typeOptions={shipmentTypes}
        />
      )}
    </>
  );
}
